import type { QueryKey } from '@tanstack/react-query';
import type { GetAllFaqsQueryParams } from '.';

export const get_all_faqs_query_key = ({ active, page = 1, quantity = 5, search }: GetAllFaqsQueryParams): QueryKey => [
	'get-all-faqs',
	active,
	page,
	quantity,
	search,
];
